import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';

const BreadcrumbHeader = ({ breadcrumbs, ...props }) => {
  return (
    <Breadcrumbs {...props}>
      {breadcrumbs.map(({ path, title }, index) => {
        return path ? (
          <MuiLink key={index} component={Link} to={path}>
            {title}
          </MuiLink>
        ) : (
          <Typography color="text.secondary" key={index}>
            {title}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

BreadcrumbHeader.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string.isRequired,
    }).isRequired,
  ),
};

export default BreadcrumbHeader;
